import CircleParser from './circle';
import GuidePointParser from './guide';

export default {
  guide: GuidePointParser,
  circle: CircleParser,
};
